module.exports = __webpack_public_path__ + "static/media/support-direct-relief@2x.b7eeecb5.png";